// extracted by mini-css-extract-plugin
module.exports = {"margin-top":"UpdatePw_margin-top__2ACFq"};